import {YesNoChoice} from '@/model/src/values/dv-3';
export default (fieldName: string): ((value: string | boolean | null) => string | boolean | null) => {
  // When value comes from DD* field, we serialize the resolved value to oui/null instead of boolean string.
  // When the value is specificaly DD6, we encode 'oui/non' to match original spec.
  if (fieldName.startsWith('DD')) {
    return value => {
      return value === 'true' ? 'oui' : fieldName === 'DD6' ? 'non' : null;
    };
  }

  switch (fieldName) {
    // Advisor code
    case 'P2':
      return value => String(value).replace(/ - /g, '-');
    // NAS
    case 'A4':
    case 'B13':
    case 'H13':
    case 'V17':
    case 'Q9':
    case 'E18':
      return value => {
        if (value === '000 000 000') return null;
        return String(value).replace(/ /g, '');
      };
    // Postal code
    case 'H9':
    case 'V13':
    case 'B9':
    case 'I28':
    case 'I37':
    case 'I48':
    case 'I129':
    case 'Q5':
    case 'M12':
    case 'E14':
      return value => String(value).replace(/ /g, '');
    // DV-3 as boolean
    case 'U1':
      return value => value === YesNoChoice.YES;
    default:
      return value => value;
  }
};
